module.exports = __webpack_public_path__ + "img/slt.b8c44bd1.jpg";